module.exports = __webpack_public_path__ + "img/PB_Logo.ca65a37.svg";